import { testsApi } from '@/api/tests';
import { useQuery } from '@tanstack/react-query';

export const getPatientTestsAssignmentsQueryKey = (patientId?: string) =>
    ['patients', patientId, 'tests'] as const;

export const usePatientTestAssignments = (patientId?: string) => {
    return useQuery({
        queryKey: getPatientTestsAssignmentsQueryKey(patientId),
        queryFn: () => testsApi.listPatientAssignments(patientId || ''),
        enabled: Boolean(patientId),
    });
};
